import {PlusCircleFilled} from "@ant-design/icons";
import {Button, Tooltip} from "antd";

type AddVariantButtonProps = {
  lengthOfFields: number;
  handleAddVariant(): void;
};

export function AddVariantButton({
  lengthOfFields,
  handleAddVariant,
}: AddVariantButtonProps) {
  return (
    <div>
      <Tooltip title={lengthOfFields > 4 ? "You can only add 5 variants" : null}>
        <Button
          disabled={lengthOfFields > 4}
          onClick={handleAddVariant}
          icon={<PlusCircleFilled />}
          size="small"
        >
          Add new add-on
        </Button>
      </Tooltip>
    </div>
  );
}
